/* eslint-disable react/prop-types */
import React from 'react';
import Image from './Image';
import GenericButton from './GenericButton';
import { useSelector, useDispatch } from 'react-redux';
import { isChrome, isIOS, isSafari } from 'react-device-detect';
import { setSelectedPackage, setIsFrameOnlySelected } from '../app/mainSlice';

/**
 *
 * @param props.imageFileName
 * @param props.imageAlt
 * @param props.title
 * @param props.description
 * @param props.dataElementId
 * @param props.dataDescription
 * @param props.className
 * @param props.frameOnlyPackage
 *
 */
const AddToCartStepButton = props => {
    const dispatch = useDispatch();
    const labels = useSelector(state => state.main.labels);
    const selectedPackage = useSelector(state => state.main.selectedPackage);
    const selectedWarranty = useSelector(state => state.main.selectedWarranty);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const isPrescriptionModalOpen = useSelector(state => state.main.isPrescriptionModalOpen);
    const isFrameOnlySelected = useSelector(state => state.main.isFrameOnlySelected);

    const handleStepButtonClick = () => {
        dispatch(setIsFrameOnlySelected(true));
        dispatch(setSelectedPackage(props.frameOnlyPackage));
    };

    const handleAddToBag = () => {
        try {
            let products = utag_data.Products;

            tealium_data2track.push({
                id: 'AddToCart',
                Products: products,
            });
        } catch (error) {
            console.error(
                'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
            );
        }

        if (props.config.actionsModule) {
            if (!props.config.cartMode) {
                props.config.actionsModule.genericAddToCart(
                    props.config.data.frame,
                    selectedPackage,
                    selectedWarranty
                );
            } else {
                props.config.actionsModule.genericSaveEditFromCart(
                    props.config.data.frame,
                    selectedPackage,
                    selectedWarranty,
                    props.config.cartMode
                );
            }
        }
    };

    return (
        <div className="step-button-container">
            <button
                className={
                    'step-button add-to-cart' +
                    (props.isInsuranceLoading ? ' step-disabled' : '') +
                    (isFrameOnlySelected ? ' add-to-cart-selected' : '') +
                    (isSafari ? ' safari' : '') +
                    (isIOS && isChrome ? ' chrome-ios' : '')
                }
                data-element-id={props.dataElementId}
                data-description={props.dataDescription}
                onClick={handleStepButtonClick}
                ref={props.firstLearnMore}
                disabled={props.isInsuranceLoading}
                tabIndex={isPrescriptionModalOpen ? '-1' : '0'}
            >
                <div className="step-button-layout">
                    <div className="step-button-image-container">
                        <Image
                            imageClass="step-button-image"
                            url={baseURLs.projectImage}
                            fileName={props.imageFileName}
                            alt={props.imageAlt}
                        />
                    </div>

                    <div className="step-button-content">
                        <div className="step-button-title">{props.title}</div>
                        {props.subtitle && (
                            <div className="step-button-subtitle">{props.subtitle}</div>
                        )}
                        {props.price == undefined ? (
                            <div
                                className="step-button-desc"
                                dangerouslySetInnerHTML={{ __html: props.description }}
                            ></div>
                        ) : null}
                        {isFrameOnlySelected && (
                            <GenericButton
                                className="filling-button add-to-bag-button"
                                handleClick={handleAddToBag}
                            >
                                {labels.addToBag}
                            </GenericButton>
                        )}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default AddToCartStepButton;
